export function createStageInjectedProxy(target, stage) {
    return new Proxy(target, {
        get(target, prop, _receiver) {
            // Only operate on string keys that are known function properties
            if (typeof prop !== 'string' || !(prop in target)) {
                return;
            }
            const original = target[prop];
            if (typeof original === 'function') {
                return function (...args) {
                    if (args.length > 0 && typeof args[0] === 'object' && args[0] !== null) {
                        const firstArgWithStage = {
                            ...args[0],
                            stage,
                        };
                        return original.apply(target, [
                            firstArgWithStage,
                            ...args.slice(1),
                        ]);
                    }
                    return original.apply(target, args);
                };
            }
            return original;
        },
    });
}
